"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestERC721__factory = exports.TestERC20USDC__factory = exports.TestERC20__factory = exports.TestERC1155__factory = exports.testErc1271WalletSol = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
exports.testErc1271WalletSol = require("./TestERC1271Wallet.sol");
var TestERC1155__factory_1 = require("./TestERC1155__factory");
Object.defineProperty(exports, "TestERC1155__factory", { enumerable: true, get: function () { return TestERC1155__factory_1.TestERC1155__factory; } });
var TestERC20__factory_1 = require("./TestERC20__factory");
Object.defineProperty(exports, "TestERC20__factory", { enumerable: true, get: function () { return TestERC20__factory_1.TestERC20__factory; } });
var TestERC20USDC__factory_1 = require("./TestERC20USDC__factory");
Object.defineProperty(exports, "TestERC20USDC__factory", { enumerable: true, get: function () { return TestERC20USDC__factory_1.TestERC20USDC__factory; } });
var TestERC721__factory_1 = require("./TestERC721__factory");
Object.defineProperty(exports, "TestERC721__factory", { enumerable: true, get: function () { return TestERC721__factory_1.TestERC721__factory; } });
//# sourceMappingURL=index.js.map